/**
 * The Documents switcher's entries UNDER A PROJECT (card 4.3): "Main" and the
 * project's documentation spaces, instead of Personal / This device / Teams.
 * Same shape as scopeChoices.js so WorkspaceSwitcher, its drag-to-reorder and
 * its drop-a-page-onto-an-entry all work unchanged:
 *
 *   Main      kind 'personal'   (a drop target, not reorderable) scopeId null
 *   a space   kind 'workspace'  (reorderable, a drop target)      scopeId = space id
 *
 * Every entry shows the same tree (`bucketScope`: the team's for a team
 * project, else the user's own — cloud or this device); the space is a filter.
 */
export const MAIN_KEY = 'space:main';
export const spaceKey = (id) => (id ? `space:${id}` : MAIN_KEY);

export function docSpaceChoices({ t, spaces = [], bucketScope }) {
  const main = {
    key: MAIN_KEY,
    kind: 'personal',
    group: 'spaces',
    scope: bucketScope,
    scopeId: null,
    label: t('docSidebar.spaces.main'),
    emptyTitle: t('docSidebar.empty.title'),
    emptyHint: t('docSidebar.spaces.emptyHint'),
  };
  return [
    main,
    ...spaces.map((s) => ({
      key: spaceKey(s.id),
      kind: 'workspace',
      group: 'spaces',
      scope: bucketScope,
      scopeId: String(s.id),
      label: s.name,
      icon: s.icon,
      color: s.color,
      space: s,
      emptyTitle: t('docSidebar.empty.title'),
      emptyHint: t('docSidebar.spaces.emptyHint'),
    })),
  ];
}

/**
 * The section id of that tree: the same string scopeChoices gives the bucket
 * (`personal` | `device` | `team:<id>`), so expand sets and MCP reveals
 * (matched by string against `sectionId`) keep working under a project.
 */
export const sectionIdOf = (scope) => (scope?.type === 'team' ? `team:${scope.teamId}` : scope?.type === 'device' ? 'device' : 'personal');

/** The tree a project's spaces show: a team project's team, else the user's own bucket. */
export function bucketScopeFor(project, personalChoiceScope) {
  const key = String(project?.scopeKey || '');
  if (key.startsWith('team:')) return { type: 'team', teamId: key.slice('team:'.length) };
  return personalChoiceScope;
}
